module.exports = __webpack_public_path__ + "static/media/flatModal.2fd0ddfb.jpg";